import { c as _c } from "react-compiler-runtime";
import { useEffect, useState } from "react";
type UseCountUpOptions = {
  start?: number;
  end: number;
  duration?: number;
  delay?: number;
  enabled?: boolean;
  decimals?: number;
  prefix?: string;
  suffix?: string;
};
export default function useCountUp(t0) {
  const $ = _c(14);
  const {
    start: t1,
    end,
    duration: t2,
    delay: t3,
    enabled: t4,
    decimals: t5,
    prefix: t6,
    suffix: t7
  } = t0;
  const start = t1 === undefined ? 0 : t1;
  const duration = t2 === undefined ? 2000 : t2;
  const delay = t3 === undefined ? 0 : t3;
  const enabled = t4 === undefined ? true : t4;
  const decimals = t5 === undefined ? 0 : t5;
  const prefix = t6 === undefined ? "" : t6;
  const suffix = t7 === undefined ? "" : t7;
  const [value, setValue] = useState(start);
  const [hasStarted, setHasStarted] = useState(false);
  let t8;
  let t9;
  if ($[0] !== delay || $[1] !== duration || $[2] !== enabled || $[3] !== end || $[4] !== hasStarted || $[5] !== start) {
    t8 = () => {
      if (!enabled || hasStarted) {
        return;
      }
      const timeout = setTimeout(() => {
        setHasStarted(true);
        const startTime = performance.now();
        const difference = end - start;
        const animate = currentTime => {
          const elapsed = currentTime - startTime;
          const progress = Math.min(elapsed / duration, 1);
          const easeOutQuart = 1 - Math.pow(1 - progress, 4);
          const currentValue = start + difference * easeOutQuart;
          setValue(currentValue);
          if (progress < 1) {
            requestAnimationFrame(animate);
          } else {
            setValue(end);
          }
        };
        requestAnimationFrame(animate);
      }, delay);
      return () => clearTimeout(timeout);
    };
    t9 = [enabled, end, start, duration, delay, hasStarted];
    $[0] = delay;
    $[1] = duration;
    $[2] = enabled;
    $[3] = end;
    $[4] = hasStarted;
    $[5] = start;
    $[6] = t8;
    $[7] = t9;
  } else {
    t8 = $[6];
    t9 = $[7];
  }
  useEffect(t8, t9);
  let t10;
  if ($[8] !== decimals || $[9] !== value) {
    t10 = value.toFixed(decimals);
    $[8] = decimals;
    $[9] = value;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  const formattedValue = `${prefix}${t10}${suffix}`;
  let t11;
  if ($[11] !== formattedValue || $[12] !== value) {
    t11 = {
      value,
      formattedValue
    };
    $[11] = formattedValue;
    $[12] = value;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  return t11;
}